import { coinsIcons } from "@Console/definitions/utils/coinsIconsObject";

export const getGamificationCoinIcon = (icon) => {
  const filteredIcon = coinsIcons?.filter((item) => item?.value === icon);
  return filteredIcon;
};
